export const setupRequestOptions = (
  method: string,
  headers: RequestInit['headers'],
  options: RequestInit,
  params?: Record<string, unknown>,
): RequestInit => {
  const requestOptions: RequestInit = {
    ...options,
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (params && method !== 'GET') {
    requestOptions.body = JSON.stringify(params);
  }

  return requestOptions;
};
